import { Action } from "redux";
import GeoCalculationItem from "../../dto/GeoCalculationItem";
import { GeoCalcStyle } from "../../types";

export const GEOCALC_GEOMETRY_LOADED = "GEOCALC_GEOMETRY_LOADED";

export interface LoadVisualisedGeoCalculationAction extends Action {
    geoCalculations: GeoCalculationItem[];
    style: GeoCalcStyle;
    calculationId?: number;
}

export const loadVisualisedGeoCalculationAction = (
    geoCalculations: GeoCalculationItem[],
    style: GeoCalcStyle
): LoadVisualisedGeoCalculationAction => {
    return {
        type: GEOCALC_GEOMETRY_LOADED,
        geoCalculations: geoCalculations,
        style: style,
    };
};
